import { connect } from "react-redux";

var RosterSelectors = require("lib/selectors/RosterSelectors");
var Spinner = require("components/utility/Spinner");

require("data/exports/export_type_selector.scss");

@connect(
    (state, props) => ({
        loading: RosterSelectors.isLoadingStudents({ state, key: 'index' }) ||
            RosterSelectors.isLoadingStudentLists({ state, key: 'index' }) ||
            RosterSelectors.isLoadingAdmins({ state, key: 'index' })
    })
)

class ExportTypeSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    ///// HELPERS /////
    renderErrorAlert(text) {
        window.wrNotifications.triggerDropDownNotification({
            text: text,
            icon: "exclamation-sign", type: "error"
        }, 3000);
    }

    ///// HANDLERS /////
    handlePrintPDF() {
        this.props.handlePrint()
    }

    handleDownloadXsl() {
        this.props.onComplete({})
    }

    ///// RENDER METHODS /////
    renderExportTypeSelector() {
        if (this.props.loading) {
            var content = <Spinner placeholder={true} scale={1.7} />
        } else {
            var content = (
                <div className="buttonContainer">
                    <button className='pdfBtn' onClick={() => this.handlePrintPDF()}>Print PDF</button>
                    <button className='xslBtn' onClick={() => this.handleDownloadXsl()}>Generate Excel</button>
                    {content}
                </div>
            )
        } 
        return content
    }

    render() {
        return (
            <div className="exportTypeSelector">
                {this.renderExportTypeSelector()}
            </div>
        );
    }
}

ExportTypeSelector.propTypes = StrictPropTypes({
    loading: PropTypes.bool,
    endOnboarding: PropTypes.func,
    handleAdvanceStage: PropTypes.func,
    onSubmit: PropTypes.func,
    onComplete: PropTypes.func,
    onRetreat: PropTypes.func,
    track: PropTypes.array,
    persistentData: PropTypes.object,
    currentAdmin: PropTypes.object,
    organizationTypes: PropTypes.array,
    organizationOptions: PropTypes.array,
    handlePrint: PropTypes.func
});

module.exports = ExportTypeSelector;


// WEBPACK FOOTER //
// ./modules/components/data/exports/ExportTypeSelector.js